import get from 'lodash/get';
import en from '../../templates/data/pl.json';

/**
 * Returns translation based on translation string
 *
 * @param {string} path
 * @returns {string}
 */
const getTranslation = (path) => {
  const translation = get(en, path);

  if (!translation) {
    // eslint-disable-next-line
    console.warn(`Translation for ${path} is missing`);
    return translation;
  }

  return translation;
};


export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        t(path) {
          return getTranslation(path);
        },
      },
    });
  },
};
